import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Globals } from '../../ressources/variables/globals';

/**
 * Service pour la gestion des permissions utilisateur
 * Note: L'authentification est gérée automatiquement via les cookies de session Laravel
 * grâce à l'intercepteur CredentialsInterceptor
 */
@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  globals = Globals;

  constructor(private http: HttpClient) {}

  readPermissions(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get(this.globals.serverEndpoint + '/api/readPermissions', { headers }).toPromise();
  }

}
